import {
    AfterContentInit,
    Component,
    ElementRef,
    EventEmitter,
    HostBinding,
    Input,
    Output,
    ViewChild
} from "@angular/core";
import {SelectorType} from "../selector-control/selector";

@Component({
    selector: "woa-radio-field",
    templateUrl: "./radio-field.component.html",
})
export class RadioFieldComponent implements AfterContentInit {
    @Input() label: string;
    @Input() message: string;
    @Input() translationParams: any = {};
    @Input() @HostBinding("class.disabled") disabled: boolean = false;
    @Input() softResizeOnSelect: boolean = false;

    @Output() selectedChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() onActivateLabel: EventEmitter<void> = new EventEmitter();

    @ViewChild("field", {read: ElementRef}) public field: ElementRef;

    SelectorType = SelectorType;

    private _selected: boolean = false;
    private fieldHeight: number = undefined;

    constructor(private element: ElementRef) {
    }

    @Input()
    get selected(): boolean {
        return this._selected;
    }

    set selected(value: boolean) {
        this._selected = value;
        this.setHeight();
    }

    ngAfterContentInit(): void {
        this.setHeight();
    }

    public setHeight(): void {
        if (this.softResizeOnSelect) {

            // Set heights back to absolute values immediately so that soft-resize is re-activated
            if (this.field.nativeElement.scrollHeight) {
                this.fieldHeight = this.field.nativeElement.scrollHeight;
            }
            if (this.fieldHeight !== undefined) {
                this.element.nativeElement.style.maxHeight = this.fieldHeight + 26 + "px";
                this.element.nativeElement.style.minHeight = this.element.nativeElement.style.maxHeight;
            }

            setTimeout(() => {
                if (!this.field.nativeElement.scrollHeight) {
                    this.setHeight();
                    return;
                }

                // Transition requires max and min height to be set absolute values (can't transition to "fit-content").
                this.fieldHeight = this.field.nativeElement.scrollHeight;
                this.element.nativeElement.style.maxHeight = this.fieldHeight + 26 + "px";
                this.element.nativeElement.style.minHeight = this.element.nativeElement.style.maxHeight;

                // 500 ms later, after the transition has taken place,
                // set the sizes back to fit-content so later changes to the content size are respected (albeit without a transition)
                setTimeout(() => {
                    this.element.nativeElement.style.maxHeight = "fit-content";
                    this.element.nativeElement.style.minHeight = "fit-content";
                }, 500);
            }, 250);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/inputs/radio-field/radio-field.component.ts